import { useEffect } from 'react';
import { useLocation,  } from 'react-router-dom';
import { useAuthStore } from '../../features/auth/store';
import { useTenantStore } from '../stores/useTenantStore';
import { UserRole } from '../../features/auth/type';

// Routes that require a merchant context for collective admins
const TENANT_SCOPED_PATHS = [
  '/products',
  '/orders',
  '/homepage-slider',
  '/product-metadata',
];

const isTenantScoped = (pathname: string) =>
  TENANT_SCOPED_PATHS.some((p) => pathname === p || pathname.startsWith(p + '/'));

const isCollectiveAdmin = (role: string | undefined) =>
  role === UserRole.COLLECTIVE_SUPERADMIN || role === UserRole.COLLECTIVE_ADMIN|| role === UserRole.COLLECTIVE_USER;

export const TenantGuard = () => {
  const location = useLocation();
  const { user } = useAuthStore();
  const { activeMerchant, openSelector, clearTenant } = useTenantStore();

  // When a collective admin hits a tenant-scoped route without a merchant, open selector
  useEffect(() => {
    if (
      isCollectiveAdmin(user?.roleName) &&
      isTenantScoped(location.pathname) &&
      !activeMerchant
    ) {
      openSelector();
    }
  }, [location.pathname, activeMerchant, user?.roleName, openSelector]);

  // Clear tenant context on logout (when user becomes null)
  useEffect(() => {
    if (!user) clearTenant();
  }, [user, clearTenant]);

  return null;
};
